/**
 * The right panel: a tab strip over Details and Claude.
 *
 * Claude is a tab rather than a fourth stacked section because a transcript
 * cannot live in the sections column. The composer has to pin to the bottom
 * and there is no bottom inside a shared scroll container, and a tool call
 * chip at the old 200px minimum width was unreadable.
 */
import { Network, Sparkles, X } from "lucide-react";
import { IconButton } from "@/ui/IconButton";
import { useUi } from "@/store/ui";
import { ChatPane } from "@/chat/ChatPane";
import { DetailsPanel } from "./DetailsPanel";
import { LocalGraphPane } from "@/graph/LocalGraphPane";
import s from "./panels.module.css";

export function RightPanel() {
  const toggleRight = useUi((u) => u.toggleRight);
  const rightTab = useUi((u) => u.rightTab);
  const setRightTab = useUi((u) => u.setRightTab);

  return (
    <>
      <div className={s.header}>
        <div className={s.tabs} role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={rightTab === "details"}
            className={[s.tab, rightTab === "details" ? s.tabActive : ""].join(" ")}
            onClick={() => setRightTab("details")}
          >
            Details
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={rightTab === "graph"}
            className={[s.tab, rightTab === "graph" ? s.tabActive : ""].join(" ")}
            onClick={() => setRightTab("graph")}
          >
            <Network size={11} /> Graph
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={rightTab === "chat"}
            className={[s.tab, rightTab === "chat" ? s.tabActive : ""].join(" ")}
            onClick={() => setRightTab("chat")}
          >
            <Sparkles size={11} /> Claude
          </button>
        </div>
        <IconButton label="Close panel" kbd="Mod+Shift+B" onClick={toggleRight}>
          <X size={14} />
        </IconButton>
      </div>
      {rightTab === "details" ? <DetailsPanel /> : rightTab === "graph" ? <LocalGraphPane /> : <ChatPane />}
    </>
  );
}
